import { GetTimeslotsResponse } from '@src/@data/types/reservations';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTimeslots } from '../timeslotUtils';
import {
  DateAndTimeRow,
  DateAndTimeRowDataWithActions,
  DateAndTimeRowProps,
} from './DateAndTimeRow';

interface AdditionalDateAndTimeRowProps
  extends Omit<DateAndTimeRowProps, 'row'> {
  getTimeslotsFromStartDate: (
    startDate: Date
  ) => Promise<GetTimeslotsResponse | undefined>;
  defaultStartDate: Date;
  id: number;
  onRowChange: (id: number, startTime?: Date) => void;
  selectedTimeslots: Date[];
  duration?: number;
}

export const AdditionalDateAndTimeRow: React.FC<AdditionalDateAndTimeRowProps> =
  ({
    defaultStartDate,
    id,
    getTimeslotsFromStartDate,
    onRowChange,
    ...props
  }) => {
    const [startDate, setStartDate] = useState(defaultStartDate);
    const [startTime, setStartTime] = useState<Date>();

    const resetStartTime = useCallback(() => {
      setStartTime(undefined);
    }, [setStartTime]);
    const getTimeslots = useCallback(
      () => getTimeslotsFromStartDate(startDate),
      [getTimeslotsFromStartDate, startDate]
    );
    const { timeslots, areTimeslotsLoading } = useTimeslots({
      isReady: !props.areTimeslotsDisabled,
      getTimeslots,
      resetStartTime,
    });

    const row: DateAndTimeRowDataWithActions = useMemo(
      () => ({
        id,
        startDate,
        setStartDate,
        startTime,
        setStartTime,
        timeslots,
        areTimeslotsLoading,
      }),
      [id, startDate, startTime, timeslots, areTimeslotsLoading]
    );

    useEffect(() => {
      onRowChange(row.id, row.startTime);
    }, [onRowChange, row]);

    return <DateAndTimeRow {...props} row={row} />;
  };
